<template>
  <div
    ref="progress"
    class="progress"
    @click="updatePosition"
    @touchstart="updatePosition"
  >
    <div
      ref="scrubber"
      class="scrubber"
      :class="{'scrubber--active': drag}"
      @mousedown="onDragStart"
      @touchstart="onDragStart"
      :style="{ left: progressPercents }"
    ></div>
    <div
      ref="played"
      class="progress__played"
      :style="{ width: progressPercents }"
    ></div>
    <div
      class="progress__loaded"
      :style="{ width: bufferPercents }"
    ></div>
  </div>
</template>

<script>

export default {
  name: 'ProgressBar',
  props: {
    buffer: {
      type: Number,
      default: 0
    },
    progress: {
      type: Number,
      default: 0
    },
    duration: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      drag: false,
      size: 0,
      currentValue: 0
    }
  },
  computed: {
    limit () {
      return [0, this.size - 1]
    },
    bufferPercents () {
      return `${this.buffer * 100}%`
    },
    progressPercents () {
      return `${this.progress * 100}%`
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.bindEvents()
      this.getStaticData()
    })
  },
  beforeDestroy () {
    this.unbindEvents()
  },
  methods: {
    bindEvents () {
      document.addEventListener('touchmove', this.updateDragger, { passive: false })
      document.addEventListener('touchend', this.onDragEnd, { passive: false })
      document.addEventListener('mousemove', this.updateDragger)
      document.addEventListener('mouseup', this.onDragEnd)
      document.addEventListener('mouseleave', this.onDragEnd)
    },
    unbindEvents () {
      document.removeEventListener('touchmove', this.updateDragger)
      document.removeEventListener('touchend', this.onDragEnd)
      document.removeEventListener('mousemove', this.updateDragger)
      document.removeEventListener('mouseup', this.onDragEnd)
      document.removeEventListener('mouseleave', this.onDragEnd)
    },
    seek (value) {
      this.$emit('seek', value)
    },
    emitTime (position) {
      const time = (position * this.duration) / this.size
      this.seek(time)
    },
    getStaticData () {
      this.size = this.$refs.progress.offsetWidth
      this.offset = this.$refs.progress.getBoundingClientRect().left
    },
    onDragStart () {
      this.drag = true
    },
    updateDragger (e) {
      if (this.drag) {
        e.preventDefault()
        this.updatePosition(e)
      }
    },
    onDragEnd () {
      this.drag = false
    },
    updatePosition (e) {
      // check if this is a Touch event
      e = e.changedTouches ? e.changedTouches[0] : e

      const position = e.clientX - this.offset
      const positionInPercents = Math.round((position * 100) / this.size)
      const [min, max] = this.limit

      if (position >= min && position <= max) {
        this.currentValue = positionInPercents
        this.emitTime(position)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

// TODO: should be converted to design-system variables

.progress {
  position: relative;
  cursor: pointer;
  height: 6px;
  background-color: rgba(255, 255, 255, .4);
  transition: all .2s ease .05s;

  &:hover {
    height: 8px;

    .scrubber {
      opacity: 1;
    }
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }

  &__loaded {
    background-color: rgba(255, 255, 255, .4);
    height: 100%;
  }

  &__played {
    position: absolute;
    background-color: $color-white;;
    transition: all 0s;
    z-index: 1;
    width: 0;
    height: 100%;
    top: 0;
    left: 0;
    will-change: width;
  }

  .scrubber {
    opacity: 0;
    position: absolute;
    cursor: pointer;
    z-index: 3;
    top: -5px;
    left: 0;
    width: 16px;
    height: 16px;
    border-radius: 8px;
    background-color: white;
    transform: translateX(-8px);
    transition: all 0s;
    will-change: transform;

    &--active {
      opacity: 1;
    }
  }
}
</style>
